import Head from 'next/head';

import CheckoutZebraLearn from '@/components/CheckoutRazorpay';
import { pageTitle } from '@/components/shared/basic/customHead';

const RazorpayCheckout = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Razorpay Checkout')}</title>
      </Head>
      <main className='h-screen flex items-center  text-[#0c1116]  dark:text-white'>
        <CheckoutZebraLearn />
      </main>
    </div>
  );
};

export default RazorpayCheckout;
